module.exports = __webpack_public_path__ + "images/file_icons_v2/gif-74e257c91d1bd1b2192fb7a36c4b7474.svg";